var Shop = React.createClass({
    mixins: [React.addons.PureRenderMixin],

    getInitialState: function() {
        ios.on(
            'shop',
            function(data) {
                if (data.id == 'nomoney') {
                    alert("You're too poor for this!")
                } else if (data.id == 'permanentpu') {
                    alert('You already have a perament PU!')
                } else if (data.id == 'permanentstar') {
                    alert('You already have a perament Star Status!')
                } else if (data.id == 'owned') {
                    alert('You already own this item!')
                }
            }.bind(this),
        )
        return null
    },

    render: function() {
        var stylehat = {
            borderColor: 'white',
            width: '80px',
            height: '80px',
            zIndex: 1,
        }
        var stylestick = {
            borderColor: 'white',
            width: '80px',
            height: '80px',
            zIndex: 1,
            padding: '6px',
            backgroundColor: 'pink',
        }
        var flexDiv = {
            display: 'flex',
            'flex-wrap': 'wrap',
        }
        var itemdiv = {
            marginRight: '60px',
            marginBottom: '30px',
        }
        return (
            <div>
				<div>
					<h1>POP SHOP</h1>
					<hr />
					Welcome to the POP SHOP. Things will be added slowly but surely, so keep playing and
					saving your coins! ♥.
				</div>
				<TabArea>
					<Tab id="sitepowerups" title="SITE POWER UPS">
					<h2>Site Power Ups</h2>
					<details open>
						<summary>STAR</summary>
						<div>
							<h4> Gives you ability to have private rooms and have a custom badge! </h4>
							<br />
							<div>
								<h4>1 Week of Star - 1,000 coins</h4>
								<h4>
									<span className="link" onClick={this.weekStar}>
										BUY!
									</span>
								</h4>
								<br />
								<h4>1 Month of Star - 3,000 coins</h4>
								<h4>
									<span className="link" onClick={this.monthStar}>
										BUY!
									</span>
								</h4>
							</div>
						</div>
						<br />
					</details>
					<details open>
						<summary>PU</summary>
						<div>
							<h4>
								{' '}
								Gives you ability to rotate, kick, broadcast messages and more even when youre not
								the host!{' '}
							</h4>
							<br />
							<div>
								<h4>1 Week of PU - 3,000 coins</h4>
								<h4>
									<span className="link" onClick={this.weekPU}>
										BUY!
									</span>
								</h4>
								<br />
								<h4>1 Month of PU - 10,000 coins</h4>
								<h4>
									<span className="link" onClick={this.monthPU}>
										BUY!
									</span>
								</h4>
							</div>
						</div>
						<br />
					</details>
					<br />
					</Tab>
					<Tab id="balloono" title="BALLOONO">
					<h2>Balloono</h2>
					<details open>
						<summary>Balloon Colors</summary>
						<h4>Customize your Balloonos!</h4>
						<br />
						<div style={flexDiv}>
						<div style={itemdiv}>
								<h4>Alien Bomb</h4>
								<img
									src="https://mobcpop.com/img/balloons/Alien Bomb.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									50,000 coins <br />
									<span
										className="link"
										onClick={() => this.balloonocolorbought('Alien Bomb', 50000)}
									>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Black Bomb</h4>
								<img
									src="https://mobcpop.com/img/balloons/Black Bomb.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									40,000 coins <br />
									<span
										className="link"
										onClick={() => this.balloonocolorbought('Black Bomb', 40000)}
									>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>White Bomb</h4>
								<img
									src="https://mobcpop.com/img/balloons/White Bomb.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									40,000 coins <br />
									<span
										className="link"
										onClick={() => this.balloonocolorbought('White Bomb', 40000)}
									>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>AppleBlossom Bomb</h4>
								<img
									src="https://mobcpop.com/img/balloons/AppleBlossom Bomb.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									25,000 coins <br />
									<span
										className="link"
										onClick={() => this.balloonocolorbought('AppleBlossom Bomb', 25000)}
									>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Charcoal Bomb</h4>
								<img
									src="https://mobcpop.com/img/balloons/Charcoal Bomb.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									25,000 coins <br />
									<span
										className="link"
										onClick={() => this.balloonocolorbought('Charcoal Bomb', 25000)}
									>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Lavender Bomb</h4>
								<img
									src="https://mobcpop.com/img/balloons/Lavender Bomb.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									25,000 coins <br />
									<span
										className="link"
										onClick={() => this.balloonocolorbought('Lavender Bomb', 25000)}
									>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Seablue Bomb</h4>
								<img
									src="https://mobcpop.com/img/balloons/Seablue Bomb.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									25,000 coins <br />
									<span
										className="link"
										onClick={() => this.balloonocolorbought('Seablue Bomb', 25000)}
									>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Tea Bomb</h4>
								<img
									src="https://mobcpop.com/img/balloons/Tea Bomb.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									25,000 coins <br />
									<span
										className="link"
										onClick={() => this.balloonocolorbought('Tea Bomb', 25000)}
									>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Orange Bomb</h4>
								<img
									src="https://mobcpop.com/img/balloons/Orange Bomb.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									25,000 coins <br />
									<span
										className="link"
										onClick={() => this.balloonocolorbought('Orange Bomb', 25000)}
									>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Red Bomb</h4>
								<img
									src="https://mobcpop.com/img/balloons/Red Bomb.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									25,000 coins <br />
									<span
										className="link"
										onClick={() => this.balloonocolorbought('Red Bomb', 25000)}
									>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Lightgray Bomb</h4>
								<img
									src="https://mobcpop.com/img/balloons/Lightgray Bomb.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									25,000 coins <br />
									<span
										className="link"
										onClick={() => this.balloonocolorbought('Lightgray Bomb', 25000)}
									>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Gold Bomb</h4>
								<img
									src="https://mobcpop.com/img/balloons/Gold Bomb.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									25,000 coins <br />
									<span
										className="link"
										onClick={() => this.balloonocolorbought('Gold Bomb', 25000)}
									>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Blue Bomb</h4>
								<img
									src="https://mobcpop.com/img/balloons/Blue Bomb.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									25,000 coins <br />
									<span
										className="link"
										onClick={() => this.balloonocolorbought('Blue Bomb', 25000)}
									>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>HotPink Bomb</h4>
								<img
									src="https://mobcpop.com/img/balloons/HotPink Bomb.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									25,000 coins <br />
									<span
										className="link"
										onClick={() => this.balloonocolorbought('HotPink Bomb', 25000)}
									>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Grape Bomb</h4>
								<img
									src="https://mobcpop.com/img/balloons/Grape Bomb.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									25,000 coins <br />
									<span
										className="link"
										onClick={() => this.balloonocolorbought('Grape Bomb', 25000)}
									>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Brown Bomb</h4>
								<img
									src="https://mobcpop.com/img/balloons/Brown Bomb.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									25,000 coins <br />
									<span
										className="link"
										onClick={() => this.balloonocolorbought('Brown Bomb', 25000)}
									>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Gold Bomb</h4>
								<img
									src="https://mobcpop.com/img/balloons/Gold Bomb.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									25,000 coins <br />
									<span
										className="link"
										onClick={() => this.balloonocolorbought('Gold Bomb', 25000)}
									>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Pink Bomb</h4>
								<img
									src="https://mobcpop.com/img/balloons/Pink Bomb.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									25,000 coins <br />
									<span
										className="link"
										onClick={() => this.balloonocolorbought('Pink Bomb', 25000)}
									>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Purple Bomb</h4>
								<img
									src="https://mobcpop.com/img/balloons/Purple Bomb.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									25,000 coins <br />
									<span
										className="link"
										onClick={() => this.balloonocolorbought('Purple Bomb', 25000)}
									>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Turquoise Bomb</h4>
								<img
									src="https://mobcpop.com/img/balloons/Turquoise Bomb.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									25,000 coins <br />
									<span
										className="link"
										onClick={() => this.balloonocolorbought('Turquoise Bomb', 25000)}
									>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Fuchsia Bomb</h4>
								<img
									src="https://mobcpop.com/img/balloons/Fuchsia Bomb.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									25,000 coins <br />
									<span
										className="link"
										onClick={() => this.balloonocolorbought('Fuchsia Bomb', 25000)}
									>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Royalblue Bomb</h4>
								<img
									src="https://mobcpop.com/img/balloons/Royalblue Bomb.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									25,000 coins <br />
									<span
										className="link"
										onClick={() => this.balloonocolorbought('Royalblue Bomb', 25000)}
									>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Lime Bomb</h4>
								<img
									src="https://mobcpop.com/img/balloons/Lime Bomb.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									25,000 coins <br />
									<span
										className="link"
										onClick={() => this.balloonocolorbought('Lime Bomb', 25000)}
									>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Navyblue Bomb</h4>
								<img
									src="https://mobcpop.com/img/balloons/Navyblue Bomb.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									25,000 coins <br />
									<span
										className="link"
										onClick={() => this.balloonocolorbought('Navyblue Bomb', 25000)}
									>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Green Bomb</h4>
								<img
									src="https://mobcpop.com/img/balloons/Green Bomb.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									25,000 coins <br />
									<span
										className="link"
										onClick={() => this.balloonocolorbought('Green Bomb', 25000)}
									>
										BUY!
									</span>
								</h4>
							</div>
						</div>
					</details>
					</Tab>
					<Tab id="pool" title="POOL">
					<h2>Pool</h2>
					<details open>
						<summary>Pool Sticks</summary>
						<h4>Buy a cue stick!</h4>
						<br />
						<div style={flexDiv}>
						<div style={itemdiv}>
								<h4>MOBCPOP</h4>
								<img
									src="https://mobcpop.com/img/sticks/MOBCPOP.png"
									class="png-over"
									style={stylestick}
								/>
								<h4>
									100,000 coins <br />
									<span
										className="link"
										onClick={() => this.poolstickbought('MOBCPOP', 100000)}
									>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Flash</h4>
								<img
									src="https://mobcpop.com/img/sticks/Flash.png"
									class="png-over"
									style={stylestick}
								/>
								<h4>
									100,000 coins <br />
									<span
										className="link"
										onClick={() => this.poolstickbought('Flash', 100000)}
									>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Pig Missile</h4>
								<img
									src="https://mobcpop.com/img/sticks/Pig Missile.png"
									class="png-over"
									style={stylestick}
								/>
								<h4>
									100,000 coins <br />
									<span
										className="link"
										onClick={() => this.poolstickbought('Pig Missile', 100000)}
									>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Flying Ham Cue</h4>
								<img
									src="https://mobcpop.com/img/sticks/Flying Ham Cue.png"
									class="png-over"
									style={stylestick}
								/>
								<h4>
									100,000 coins <br />
									<span
										className="link"
										onClick={() => this.poolstickbought('Flying Ham Cue', 100000)}
									>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Katana</h4>
								<img
									src="https://mobcpop.com/img/sticks/Katana.png"
									class="png-over"
									style={stylestick}
								/>
								<h4>
									100,000 coins <br />
									<span
										className="link"
										onClick={() => this.poolstickbought('Katana', 100000)}
									>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Cricket Bat</h4>
								<img
									src="https://mobcpop.com/img/sticks/Cricket Bat.png"
									class="png-over"
									style={stylestick}
								/>
								<h4>
									100,000 coins <br />
									<span
										className="link"
										onClick={() => this.poolstickbought('Cricket Bat', 100000)}
									>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Purple Lightsaber</h4>
								<img
									src="https://mobcpop.com/img/sticks/Purple Lightsaber.png"
									class="png-over"
									style={stylestick}
								/>
								<h4>
									100,000 coins <br />
									<span
										className="link"
										onClick={() => this.poolstickbought('Purple Lightsaber', 100000)}
									>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Green Lightsaber</h4>
								<img
									src="https://mobcpop.com/img/sticks/Green Lightsaber.png"
									class="png-over"
									style={stylestick}
								/>
								<h4>
									100,000 coins <br />
									<span
										className="link"
										onClick={() => this.poolstickbought('Green Lightsaber', 100000)}
									>
										BUY!
									</span>
								</h4>
							</div>

						</div>
					</details>
					</Tab>
					<Tab id="profile" title="PROFILE ADD ONS">
					<h2>Profile Perks</h2>
					<details open>
						<summary>Waiting Room Photo Frames</summary>
						<h4> Keep your profile picture cozy while you wait </h4>
						<br />
						<div style={flexDiv}>
							<div style={itemdiv}>
								<h4>MOBCween 2022</h4>
								<img
									src="https://mobcpop.com/img/frames/MOBCween 2022.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									2,500 coins <br />
									<span className="link" onClick={() => this.frameBought('MOBCween 2022', 2500)}>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Flashy Halloween 2022</h4>
								<img
									src="https://mobcpop.com/img/frames/Flashy Halloween 2022.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									30,000 coins <br />
									<span className="link" onClick={() => this.frameBought('Flashy Halloween 2022', 30000)}>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Tonk</h4>
								<img
									src="https://mobcpop.com/img/frames/tonk.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									2,500 coins <br />
									<span className="link" onClick={() => this.frameBought('tonk', 2500)}>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Cuacka</h4>
								<img
									src="https://mobcpop.com/img/frames/cuacka.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									2,500 coins <br />
									<span className="link" onClick={() => this.frameBought('cuacka', 2500)}>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Caney Christmas</h4>
								<img
									src="https://mobcpop.com/img/frames/Caney Christmas.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									2,500 coins <br />
									<span className="link" onClick={() => this.frameBought('Caney Christmas', 2500)}>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Christmas</h4>
								<img
									src="https://mobcpop.com/img/frames/christmas.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									30,000 coins <br />
									<span className="link" onClick={() => this.frameBought('christmas', 30000)}>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Lovels</h4>
								<img
									src="https://mobcpop.com/img/frames/lovels.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									30,000 coins <br />
									<span className="link" onClick={() => this.frameBought('lovels', 30000)}>
										BUY!
									</span>
								</h4>
							</div>

							<div style={itemdiv}>
								<h4>Halloween</h4>
								<img
									src="https://mobcpop.com/img/frames/halloween.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									30,000 coins <br />
									<span className="link" onClick={() => this.frameBought('halloween', 30000)}>
										BUY!
									</span>
								</h4>
							</div>
						</div>
					</details>
					<br />
					<hr />
					<details open>
						<summary>Waiting Room Hats</summary>
						<h4> Something to flaunt while you wait </h4>
						<br />
						<div style={flexDiv}>
							<div style={itemdiv}>
								<h4>Christmas Hat</h4>
								<img
									src="https://mobcpop.com/img/hats/christmas.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									10,000 coins <br />
									<span className="link" onClick={() => this.hatBought('christmas', 10000)}>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Pumpkin</h4>
								<img
									src="https://mobcpop.com/img/hats/pumpkin.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									10,000 coins <br />
									<span className="link" onClick={() => this.hatBought('pumpkin', 10000)}>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Antlers</h4>
								<img
									src="https://mobcpop.com/img/hats/antlers.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									10,000 coins <br />
									<span className="link" onClick={() => this.hatBought('antlers', 10000)}>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Astronaut</h4>
								<img
									src="https://mobcpop.com/img/hats/astronaut.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									10,000 coins <br />
									<span className="link" onClick={() => this.hatBought('astronaut', 10000)}>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Candy Cane</h4>
								<img
									src="https://mobcpop.com/img/hats/candycane.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									10,000 coins <br />
									<span className="link" onClick={() => this.hatBought('candycane', 10000)}>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Slug</h4>
								<img
									src="https://mobcpop.com/img/hats/slug.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									10,000 coins <br />
									<span className="link" onClick={() => this.hatBought('slug', 10000)}>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Shrek</h4>
								<img
									src="https://mobcpop.com/img/hats/shrek.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									10,000,000 coins <br />
									<span className="link" onClick={() => this.hatBought('shrek', 10000000)}>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Flower</h4>
								<img
									src="https://mobcpop.com/img/hats/flower.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									10,000 coins <br />
									<span className="link" onClick={() => this.hatBought('flower', 10000)}>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Heart</h4>
								<img
									src="https://mobcpop.com/img/hats/heart.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									10,000 coins <br />
									<span className="link" onClick={() => this.hatBought('heart', 10000)}>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Fishy</h4>
								<img
									src="https://mobcpop.com/img/hats/fishy.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									10,000 coins <br />
									<span className="link" onClick={() => this.hatBought('fishy', 10000)}>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Fez</h4>
								<img src="https://mobcpop.com/img/hats/fez.png" class="png-over" style={stylehat} />
								<h4>
									10,000 coins <br />
									<span className="link" onClick={() => this.hatBought('fez', 10000)}>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Ushanka</h4>
								<img
									src="https://mobcpop.com/img/hats/ushanka.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									10,000 coins <br />
									<span className="link" onClick={() => this.hatBought('ushanka', 10000)}>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Loono</h4>
								<img
									src="https://mobcpop.com/img/hats/loono.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									10,000 coins <br />
									<span className="link" onClick={() => this.hatBought('loono', 10000)}>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Bolty</h4>
								<img
									src="https://mobcpop.com/img/hats/bolty.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									10,000 coins <br />
									<span className="link" onClick={() => this.hatBought('bolty', 10000)}>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Bolto</h4>
								<img
									src="https://mobcpop.com/img/hats/boltogem.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									10,000 coins <br />
									<span className="link" onClick={() => this.hatBought('boltogem', 10000)}>
										BUY!
									</span>
								</h4>
							</div>
							<div style={itemdiv}>
								<h4>Cloudie</h4>
								<img
									src="https://mobcpop.com/img/hats/cloudie.png"
									class="png-over"
									style={stylehat}
								/>
								<h4>
									10,000 coins <br />
									<span className="link" onClick={() => this.hatBought('cloudie', 10000)}>
										BUY!
									</span>
								</h4>
							</div>
						</div>
						<br />
					</details>
					</Tab>

				</TabArea>
				<div>
					<SeeAlso />
				</div>
			</div>
        )
    },

    hatBought: function(type, cost) {
        var username = window.user.username
        if (confirm('Do you want to buy ' + type + ' hat? It will cost you ' + cost + ' coins!')) {
            emit({
                id: 'hatBought',
                u: username,
                t: type,
                c: cost,
            })
        }
    },

    frameBought: function(type, cost) {
        var username = window.user.username
        if (confirm('Do you want to buy ' + type + ' frame? It will cost you ' + cost + ' coins!')) {
            emit({
                id: 'frameBought',
                u: username,
                t: type,
                c: cost,
            })
        }
    },
    poolstickbought: function(type, cost) {
        var username = window.user.username
        if (confirm('Do you want to buy ' + type + '? It will cost you ' + cost + ' coins!')) {
            emit({
                id: 'stickbought',
                u: username,
                t: type,
                c: cost,
            })
        }
    },
    balloonocolorbought: function(type, cost) {
        var username = window.user.username
        if (confirm('Do you want to buy ' + type + '? It will cost you ' + cost + ' coins!')) {
            emit({
                id: 'colorbought',
                u: username,
                t: type,
                c: cost,
            })
        }
    },
    weekPU: function() {
        var username = window.user.username
        if (confirm('Do you want to buy PU for a week? It will cost you 3,000 coins!')) {
            emit({
                id: 'weekpu',
                u: username,
            })
        }
    },
    monthPU: function() {
        var username = window.user.username
        if (confirm('Do you want to buy PU for a month? It will cost you 10,000 coins!')) {
            emit({
                id: 'monthpu',
                u: username,
            })
        }
    },
    weekStar: function() {
        var username = window.user.username
        if (confirm('Do you want to buy Star for a week? It will cost you 1,000 coins!')) {
            emit({
                id: 'weekstar',
                u: username,
            })
        }
    },
    monthStar: function() {
        var username = window.user.username
        if (confirm('Do you want to buy Star for a month? It will cost you 3,000 coins!')) {
            emit({
                id: 'monthstar',
                u: username,
            })
        }
    },
})